import sanityClient from '@sanity/client';

export default sanityClient({
    projectId: 'xxyi1ark',
    dataset: 'sanity-dataset'
})